import LoginContainer from 'containers/LoginContainer';
import React from 'react';

type Props = {};

export default function LoginPage({}: Props) {
  return <LoginContainer />;
}
